export default "__VITE_ASSET__Bwg6H4BH__"